import React from 'react'
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core";


import toTopSvg from '../../assets/svg/toTop.svg'

const useStyles = makeStyles({
	toTop: {
		position: 'fixed',
		bottom: '23px',
		right: '23px',
		display: 'flex',
		flexFlow: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '64px',
		height: '64px',
		paddingBottom: '6px',
		background: '#0F55A4',
		color: '#fff',
		fontSize: '12px',
		lineHeight: '12px',
		borderRadius: '50%',
		boxSizing: 'border-box',
		cursor: 'pointer',
		'& img': {
			width: '22px',
			height: '24px',
			marginBottom: '2px'
		}
	}
});
export default function ToTop(props) {
  const {  } = props
  const classes = useStyles();

  
  const toPageTop = () => {
    window.scrollTo({
			top: 0,
			behavior: 'smooth'
		})
  }

  return (
    <div className={classes.toTop} onClick={toPageTop}>
      <img src={toTopSvg}/>
			<span>返回顶部</span>
    </div>
  )
}
